import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const StoreItemAreaTemporarySkeleton: FC = () => (
  <Stack spacing={1} width={80}>
    <Skeleton variant="rectangular" sx={{ width: 60, height: 80 }} />
    <SkeletonText variant="overline" width="60%" />
    <SkeletonText variant="overline" width="60%" />
  </Stack>
)
